import { render, staticRenderFns } from "./YkCampMenuItems.vue?vue&type=template&id=40f179db&"
import script from "./YkCampMenuItems.vue?vue&type=script&lang=js&"
export * from "./YkCampMenuItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports